import { render, staticRenderFns } from "./PreSale.vue?vue&type=template&id=6ee152fa&scoped=true&"
import script from "./PreSale.vue?vue&type=script&lang=js&"
export * from "./PreSale.vue?vue&type=script&lang=js&"
import style0 from "./PreSale.vue?vue&type=style&index=0&id=6ee152fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee152fa",
  null
  
)

export default component.exports